import { render, staticRenderFns } from "./ResourceYaml.vue?vue&type=template&id=2441a635&scoped=true&"
import script from "./ResourceYaml.vue?vue&type=script&lang=js&"
export * from "./ResourceYaml.vue?vue&type=script&lang=js&"
import style0 from "./ResourceYaml.vue?vue&type=style&index=0&id=2441a635&lang=scss&scoped=true&"
import style1 from "./ResourceYaml.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441a635",
  null
  
)

export default component.exports